exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-288b2b32] {\n    -webkit-box-pack: center;\n            justify-content: center;\n}\n", ""]);

// exports
